import React from 'react'
import icon1 from '../images/icon1.png'
import icon2 from '../images/icon2.png'
import icon3 from '../images/icon3.png'
import '../style/whoami.css'

const WhoWeHelp = () => {
    return (
        <>
            <section style={{ backgroundColor: '#040f2e' }}>
                <div className='container'>Hire us For
                    <div className='ok' style={{ display: 'flex', justifyContent: 'center' }} data-aos="fade-up" data-aos-offset="250" data-aos-duration="1500" mirror='true'>
                        <h3 style={{ padding: '7px', color: 'white', marginTop: '20px', lineHeight: '45px', fontFamily: "Merriweather" }}>WHO WE HELP</h3>
                    </div>
                </div>
                <div className='container' >
                    <div className='row' style={{ marginTop: "30px", paddingBottom: '50px' }} id='whoWe'>
                        <div className='col-sm'>
                            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '40px', fontFamily: "Merriweather", color: 'white' }}><img src={icon1} style={{ marginRight: '20px' }} alt="icon1" />Early Stage</p>
                            <p style={{ marginTop: '30px', fontSize: '15px', color: 'white', }}>Test your ideas like a mad scientist, then build a rocket-powered business model with our help. Get the keys to the capital kingdom and blast off to success!</p>
                        </div>
                        <div className='col-sm'>
                            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '40px', fontFamily: "Merriweather", color: 'white' }}><img src={icon2} style={{ marginRight: '20px' }} alt="icon2" />SMBs</p>
                            <p style={{ marginTop: '28px', fontSize: '15px', color: 'white' }}>Fine-tune your operations like a master chef, turning up the heat on profitability. Let us sprinkle some coaching magic and sprinkle in digital wizardry for extra flavor!</p>
                        </div>
                        <div className='col-sm'>
                            <p style={{ fontSize: '24px', fontWeight: '600', lineHeight: '40px', fontFamily: "Merriweather", color: 'white' }}><img src={icon3} style={{ marginRight: '20px' }} alt="icon3" />Corporate</p>
                            <p style={{ marginTop: '28px', fontSize: '15px', color: 'white' }}>Sharpen your leadership skills with our secret sauce of experiential learning. Level up your stakeholder game and become the business hero you were always meant to be.</p>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default WhoWeHelp
